<template>
  <div class="w-100">
    <div class="row">
      <div class="col-3">
        <b-form-group
            :label="$t('reports.filter.date_from')"
            label-for="dateFrom"
        >
          <date-range-picker v-model="dateFrom"
                             :locale="{firstDay: 1, format: 'yyyy-mm-dd'}"
                             style="width: 100%;"
                             :singleDatePicker="true"
                             :time-picker="false"
                             :ranges="false"
                             :autoApply="true"
                             :opens="'right'">
            <template v-slot:input="picker" style="min-width: 350px;">
              <CalendarPlaceholder :date="picker.startDate" placeholder="reports.filter.calendar_placeholder"></CalendarPlaceholder>
            </template>
          </date-range-picker>
        </b-form-group>
      </div>
      <div class="col-3">
        <b-form-group
            :label="$t('reports.filter.date_from')"
            label-for="dateFrom"
        >
          <date-range-picker v-model="dateTo"
                             :locale="{firstDay: 1, format: 'yyyy-mm-dd'}"
                             style="width: 100%;"
                             :singleDatePicker="true"
                             :time-picker="false"
                             :ranges="false"
                             :autoApply="true"
                             :opens="'right'">
            <template v-slot:input="picker" style="min-width: 350px;">
              <CalendarPlaceholder :date="picker.startDate" placeholder="reports.filter.calendar_placeholder"></CalendarPlaceholder>
            </template>
          </date-range-picker>
        </b-form-group>
      </div>
      <div class="col-3 d-flex align-items-end mb-3">
        <b-button class="btn" variant="secondary" @click="clearFilters">{{ $t('reports.btn.clear') }}</b-button>
        <b-button class="btn ml-2" variant="primary" @click="getReport">{{ $t('reports.btn.apply') }}</b-button>
      </div>
    </div>

    <template v-if="show">
      <div class="row mt-2">
        <div class="col-12">
          <div class="questions sygni-grid">
            <div class="">
              <div class="row mt-2">
                <div class="col-12">
                  <div class="table-responsive">
                    <b-table striped show-empty
                             :empty-text="$t('table.no_results')"
                             :busy="isBusy"
                             hover
                             head-variant="dark"
                             outlined
                             :no-local-sorting="true"
                             :items="countries"
                             :fields="fields">

                      <template #cell(country)="data">
                        {{ data.item.country ? (data.item.country === allCountries ? $t('reports.table.all_countries') : data.value) : $t('reports.table.players_without_country') }}
                      </template>

                      <template #cell(actions)="data">
                        <div v-if="data.item.country && data.item.country !== allCountries" class="table-action--cell">
                          <b-button variant="success" size="sm" @click="openCountryDetails(data.item)">
                            {{ $t('btn.reports.show_country_details') }}
                          </b-button>
                        </div>
                      </template>

                    </b-table>
                  </div> <!-- #table-responsive-->
                </div>
              </div>
            </div> <!-- #card-body-->
          </div> <!-- #card questions sygni-grid-->
        </div>
      </div>
    </template>
    <div class="spinner-wrapper" v-else>
      <b-spinner></b-spinner>
    </div>
  </div>

</template>

<script>
import DateRangePicker from "../../../components/DateRangePicker/components/DateRangePicker";
import {mapState} from "vuex";
import moment from "moment";
import CalendarPlaceholder from "./CalendarPlaceholder";

export default {
  components: {
    DateRangePicker,
    CalendarPlaceholder
  },
  data() {
    return {
      gridGetUrl: this.url,
      show: true,
      limit: 10,
      offset: 0,
      allCountries: 'ALL_COUNTRIES',
      fields: [
        {key: 'country', label: this.$t('table.header.reports.country')},
        {key: 'playersCount', label: this.$t('table.header.reports.players_count')},
        {key: 'actions', label: this.$t('table.header.reports.actions')}
      ],
      items: [],
      dateFrom: {
        startDate: null
      },
      dateTo: {
        startDate: null
      }
    };
  },
  mounted() {
    this.getReport();
  },
  methods: {
    clearFilters() {
      this.dateFrom = { startDate: null };
      this.dateTo = { startDate: null };

      this.getReport();
    },
    openCountryDetails(country) {
      const routeParams = {
        country: country.country,
        date: {
          dateFrom: this.dateFrom,
          dateTo: this.dateTo
        }
      }

      this.$router.push({ name: 'profile-countries-details', params: routeParams })
    },
    getReport() {
      const date = {
        dateFrom: this.dateFrom.startDate ? moment(this.dateFrom.startDate).format('YYYY-MM-DD') : null,
        dateTo: this.dateTo.startDate ? moment(this.dateTo.startDate).format('YYYY-MM-DD') : null
      }

      this.$store.dispatch('reports/getProfileCountriesReport', date);
    }
  },
  computed: {
    ...mapState({
      isBusy: (state) => state.reports.isBusy
    }),
    countries: function () {
      const arr = this.$store.getters["reports/sortedCountriesByPlayersCount"];
      let playerCountriesSum = 0;

      arr.forEach(country => {
        playerCountriesSum += country.playersCount;
      });

      arr.unshift({  country: this.allCountries, playersCount: playerCountriesSum });

      return arr;
    },

    apiKey: function () {
      return this.$store.getters["root/apiKey"];
    }
  }
}
</script>
